module.exports = __webpack_public_path__ + "static/media/plus_icon.9152de7b.svg";